class HeaderLinks extends HTMLElement {
  constructor() {
    super();
    this.linksWithSubmenu = this.querySelectorAll(".has-submenu");
    this.clickHandler = this.handleClick.bind(this);
    this.documentClickHandler = this.handleDocumentClick.bind(this);
  }
  connectedCallback() {
    this.linksWithSubmenu.forEach((el) => {
      el.querySelector("span").addEventListener("click", this.clickHandler);
    });

    document.addEventListener("click", this.documentClickHandler);
  }

  handleClick(event) {
    event.stopPropagation();
    const menuItem = event.target.closest(".has-submenu");

    this.closeOtherMenus(menuItem);
    if (menuItem.dataset.url && menuItem.classList.contains("active")) {
      window.location.href = menuItem.dataset.url;
      return;
    }
    menuItem.classList.toggle("active");
    menuItem.querySelector("div").classList.toggle("active");

    if (menuItem.classList.contains("active")) {
      this.checkMenuPosition(menuItem);
    } else {
      this.cleanupMenuPosition(menuItem);
    }
  }

  checkMenuPosition(menuItem) {
    const viewportWidth = window.innerWidth;

    // Find the direct dropdown for this menu item
    let dropdown = null;
    for (const child of menuItem.children) {
      if (
        child.classList.contains("header-links--links") ||
        child.classList.contains("header-links--childs-links") ||
        child.classList.contains("header-links--last-level")
      ) {
        dropdown = child;
        break;
      }
    }
    if (!dropdown) return;

    setTimeout(() => {
      const rect = dropdown.getBoundingClientRect();

      if (rect.right > viewportWidth - 10) {
        menuItem.classList.add('left-dropdown-menu');
      } else if (rect.left < 10) {
        menuItem.classList.remove('left-dropdown-menu');
      }

      // Border-radius logic for first-level dropdown
      if (
        menuItem.classList.contains("main-level") &&
        dropdown.classList.contains("header-links--links")
      ) {
        const spanEl = menuItem.querySelector(":scope > span");
        if (spanEl && spanEl.scrollWidth >= dropdown.scrollWidth) {
          if (menuItem.classList.contains("left-dropdown-menu")) {
            dropdown.style.borderRadius = "0 0 12px 12px";
          } else {
            dropdown.style.borderRadius = "0 0 12px 12px";
          }
        } else {
          // Reset to CSS default (left-dropdown-menu class handles via CSS)
          dropdown.style.borderRadius = "";
        }
      }
    }, 10);
  }

  cleanupMenuPosition(menuItem) {
    menuItem.classList.remove('left-dropdown-menu');
    const dropdown = menuItem.querySelector(".header-links--links, .header-links--childs-links, .header-links--last-level");
    if (dropdown) {
      dropdown.style.borderRadius = "";
    }
  }

  closeOtherMenus(currentItem) {
    let parentContainer;
    if (currentItem.closest(".header-links--last-level")) {
      parentContainer = currentItem
        .closest(".header-links--last-level")
        .closest(".has-submenu");
    } else if (currentItem.closest(".header-links--childs-links")) {
      parentContainer = currentItem
        .closest(".header-links--childs-links")
        .closest(".has-submenu");
    } else if (currentItem.closest(".header-links--links")) {
      parentContainer = currentItem
        .closest(".header-links--links")
        .closest(".has-submenu");
    } else {
      parentContainer = this;
    }

    let siblings;
    if (parentContainer === this) {
      siblings = Array.from(this.children).filter((child) =>
        child.classList.contains("has-submenu")
      );
    } else {
      const parentDropdown = parentContainer.classList.contains(
        "header-link--child-sub"
      )
        ? parentContainer.querySelector(".header-links--last-level")
        : parentContainer.classList.contains("header-link--child")
          ? parentContainer.querySelector(".header-links--childs-links")
          : parentContainer.querySelector(".header-links--links");

      siblings = Array.from(parentDropdown?.children || []).filter(
        (child) =>
          child.classList.contains("has-submenu") ||
          child.classList.contains("header-link--child") ||
          child.classList.contains("header-link--child-sub") ||
          child.classList.contains("header-links--last-item")
      );
    }

    siblings.forEach((sibling) => {
      if (sibling !== currentItem && sibling.classList.contains("active")) {
        sibling.classList.remove("active");
        const dropdowns = sibling.querySelectorAll("div.active");
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove("active");
        });
        const activeSubmenuItems = sibling.querySelectorAll(
          ".has-submenu.active"
        );
        activeSubmenuItems.forEach((submenuItem) => {
          submenuItem.classList.remove("active");
        });
      }
    });
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeAllMenus();
    }
  }

  closeAllMenus() {
    const openMenus = this.querySelectorAll(".has-submenu.active");
    openMenus.forEach((menu) => {
      menu.classList.remove("active");
      const activeDropdowns = menu.querySelectorAll("div.active");
      activeDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("active");
      });
    });
  }
}
customElements.define("header-links", HeaderLinks);
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.openBtn = this.querySelector(".header--mobile-menu--open");
    this.closeBtn = this.querySelector(".header--mobile-menu--close");
    this.menuContainer = this.querySelector(".mobile-menu-container");

    this.closeBtn.style.display = "none";

    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;
    this.menuContainer.style.top = `${Math.max(headerHeight - 25, 0)}px`;

    this.openBtn.addEventListener("click", () => this.openMenu());
    this.closeBtn.addEventListener("click", () => this.closeMenu());

    this.menuContainer.addEventListener("click", (e) => {
      const toggleRow = e.target.closest(".menu-toggle");
      if (!toggleRow) return;

      e.stopPropagation();

      const item = toggleRow.parentElement;
      const isOpen = item.classList.contains("open");
      const parentList = item.parentElement;

      Array.from(parentList.children).forEach((sibling) => {
        if (sibling !== item && sibling.classList.contains("open")) {
          sibling.querySelectorAll(".open").forEach((el) => el.classList.remove("open"));
          sibling.classList.remove("open");
        }
      });

      item.classList.toggle("open", !isOpen);
    });

    document.addEventListener("click", (e) => {
      if (this.isOpen && !this.contains(e.target)) {
        this.closeMenu();
      }
    });
  }

  openMenu() {
    this.isOpen = true;
    this.openBtn.style.display = "none";
    this.closeBtn.style.display = "flex";
    this.menuContainer.style.transform = "none";
    const header = document.querySelector(".cstm-header");
    header.style.zIndex = "3";
    document.body.style.overflow = "hidden";
  }

  closeMenu() {
    this.isOpen = false;
    this.openBtn.style.display = "flex";
    this.closeBtn.style.display = "none";
    this.menuContainer.style.transform = "translate(-100%)";
    const header = document.querySelector(".cstm-header");
    header.style.zIndex = "";
    document.body.style.overflow = "";
    this.querySelectorAll(".open").forEach((el) => el.classList.remove("open"));
  }
}

customElements.define("mobile-menu", MobileMenu);

document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.link-list--link, .link-list--child-link');
  const topDropdowns = document.querySelectorAll('.link-list--dropdown');
  
  const calculateMenuDirections = () => {
    topDropdowns.forEach(dropdown => {
      dropdown.classList.remove('open-left');
      const firstLevel = dropdown.querySelector(':scope > .link-list--links');
      if (firstLevel) {
        firstLevel.style.left = '';
        firstLevel.style.right = '';
        
        const rect = firstLevel.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        
        if (rect.right > viewportWidth - 20) {
          dropdown.classList.add('open-left');
        }
      }
    });

    menuItems.forEach(item => {
      item.classList.remove('open-left');
      for (let i = 0; i < item.children.length; i++) {
        if (item.children[i].classList.contains('link-list--childs-links') || 
            item.children[i].classList.contains('link-list--sub-links')) {
          item.children[i].style.left = '';
          item.children[i].style.right = '';
        }
      }
    });

    menuItems.forEach(item => {
      let submenu = null;
      for (let i = 0; i < item.children.length; i++) {
        if (item.children[i].classList.contains('link-list--childs-links') || 
            item.children[i].classList.contains('link-list--sub-links')) {
          submenu = item.children[i];
          break;
        }
      }
      
      if (!submenu) return;
      
      const rect = submenu.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      
      if (rect.right > viewportWidth - 20) {
        item.classList.add('open-left');
      }
    });
  };

  calculateMenuDirections();
  
  window.addEventListener('resize', calculateMenuDirections);
});
